export var LivechatPermission;
(function (LivechatPermission) {
    LivechatPermission["Livechat"] = "live_chat";
    LivechatPermission["LivechatTransitionScreen"] = "live_chat_transition_screen";
})(LivechatPermission || (LivechatPermission = {}));
